//
//
//
//

export default {
  props: {
    lineData: {
      type: Array, default: () => []
    },
    name: {
      type: String, default: ''
    }
  },
  data () {
    return {
      myChart: null // 图表实例
    }
  },
  watch: {
    // 监听屏幕宽度的变化
    '$store.state.screenWidth' (newV) {
      this.myChart?.resize()
    },
    lineData: {
      handler (newVal) {
        this.getLineCharts()
      },
      deep: true
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.getLineCharts()
    })
  },
  beforeDestroy () {
    this.myChart?.clear() // 清空当前实例
    this.myChart?.dispose() // 销毁图表
    this.myChart = null
  },
  methods: {
    getLineCharts () {
      const [xData, data2] = [[], []]
      this.lineData.forEach((item) => {
        xData.push(item.date)
        data2.push({
          name: item.date,
          value: item.lots
        })
      })
      this.myChart = this.$echarts.init(document.getElementsByClassName('tran-trend-charts')[0])
      const option = {
        grid: {
          top: '20%',
          bottom: 0,
          right: '6%',
          left: '2%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: xData,
            axisTick: {
              show: false
            },
            splitLine: { // 网格线
              lineStyle: {
                type: 'dashed', // 设置网格线类型 dotted：虚线   solid:实线
                color: 'rgba(230, 230, 230, 1)'
              },
              show: true // 隐藏或显示
            },
            axisLine: {
              show: true,
              lineStyle: {
                // type: "dashed",
                color: 'rgba(41, 41, 41, 1)',
                width: 1
              }
            },
            axisLabel: {
              color: 'rgba(61, 61, 61, 1)',
              margin: 9
            }
          }
        ],
        yAxis: [
          {
            name: 'Lots',
            nameTextStyle: { // 关键代码
              padding: [0, 0, 0, -50],
              color: '#A3A3A3'
            },
            type: 'value',
            axisLabel: {
              color: 'rgba(204, 204, 204, 1)'
            },
            splitLine: {
              lineStyle: {
                type: 'dashed',
                color: ['rgba(0, 0, 0, 0.05)']
              }
            }
          }
        ],
        tooltip: {
          confine: true,
          borderWidth: 0,
          trigger: 'axis',
          backgroundColor: 'rgba(0,0,0,.8)',
          formatter: (params) => {
            return `<div class="tooltip-box">
            <div class="item item1"><span> ${params[0].name} </span></div>
            <div class="item">${params[0].value} lots</div>
            </div>`
          },
          axisPointer: {
            type: 'none'
          }
        },
        series: [
          {
            name: '',
            type: 'bar',
            barMaxWidth: 16,
            barMinHeight: 10,
            itemStyle: {
              color: 'rgba(59, 118, 246, 1)'
            },
            emphasis: {
              color: '#96B9FF'
            },
            data: data2
          }
        ]
      }
      this.myChart?.setOption(option, true)
    }
  }
}
